<div class="block-schedule__top">
    <ridango-ui-back-button (onBack)="back()">{{'LOCAL_BTN_BACK' | translate}}
    </ridango-ui-back-button>

    <h1 class="flex-center flex-start full-width min-height-60"><span
            class="flex-center route-list--number">{{routeName}}</span>{{routeDirection}}</h1>
</div>

<div class="block-schedule__bottom" [attr.aria-busy]="!(stopsLoading$ | async)">
    <ridango-ui-basic-loading-spinner *ngIf="stopsLoading$ | async"
        [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
    </ridango-ui-basic-loading-spinner>

    <ng-container *ngIf="!(stopsLoading$ | async)">
        <ul class="remove-bullets route-list">
            <li *ngFor="let id of (routeStopsIds$ | async)" role="none">
                <a [routerLink]="['/schedule/routes', routeId, 'directions', directionId ,'stops', id]  | localize" role="menuitem"
                    class="link link--no-line link--no-hover flex-center full-width min-height-50"
                    (keydown)="setFocusOnNextItem($event, routeStopsIds.length)" #listItem>
                    <span class="flex-center route-list--stop"></span>
                    <span class="line-intermediate"></span>
                    <div class="flex flex1 position-relative min-height-60 padding-10">
                        <span class="flex1 margin-right-10 align-self-center" role="text">{{(routeStops$ |
                            async)[id].stop_name}}</span>

                        <span class="icon icon-arrow-right-link align-self-center"></span>

                        <div class="route-list--hr"></div>
                    </div>
                </a>
            </li>
        </ul>
    </ng-container>
</div>
